// extracted by mini-css-extract-plugin
export default {"searchContainer":"AllForms_searchContainer__b2tOb","buttonContainer":"AllForms_buttonContainer__UqtK6"};